<!-- eslint-disable -->
<template lang="pug">
    .box
        .box-body
            .box-body__title {{ $i18n.t('battle.battle_layout_trainings') }}
            .box-body__create-battle
                router-link.button.battle-create-button(:to=`{name: 'battle-training:form'}`)
                    | {{ $i18n.t('battle.battle_list_createTraining') }}
            cs-loader(v-if="isLoading")
            .box-body__battles(v-else-if="battlesExists")
                battle(
                    v-for="battle in battles",
                    :battle="battle",
                    :key="battle.id",
                    @delete="handleBattleDelete"
                    @showListOpponents="showListOpponents",
                    @showDescription="showDescription"
                    @click.native="showBattle(battle.id)"
                )
            div.box-body__battles_empty(v-else) {{ $i18n.t('battle.battle_list_noAvailableBattles') }}
            .box-body__pagination(v-if="battlesExists && lastPage > 1 && !isLoading")
                router-link.prev-page(:class="{'is-disabled': isFirstPage}", :to='{query: {page: currentPage - 1}}')
                    img(src="../../../assets/images/battles/list/left-angle.svg")
                nav
                    ul.pagination-pages-numbers(v-if='lastPage > 1')
                        li(v-for='pageNumber in pages')
                            template(v-if="pageNumber === '...'")
                                span.pagination-ellipsis &mldr;
                            template(v-else)
                                router-link.pagination-link(
                                    :to='{ query: {page: pageNumber} }'
                                    :class="{'is-current': pageNumber === currentPage}"
                                )
                                    | {{ pageNumber }}
                router-link.next-page(:class="{'is-disabled': isLastPage}", :to='{query: {page: currentPage + 1}}')
                    img(src="../../../assets/images/battles/list/right-angle.svg")
            battle-modal(
                v-if="showBattleModal",
                :battle="battle",
                @close="showBattleModal = false",
                @showListOpponents="showListOpponents"
            )
</template>

<script>
    /*eslint-disable*/
    import paginate from '../../../utils/trainer/paginate';
    import BattleApi from '../../../api/battle';
    import { mapState } from 'vuex';
    import _ from 'lodash';

    import AchievementsBanner from '../battles/AchievementsBanner.vue';
    import Battle from '../battles/Battle.vue';
    const BattleModal = () => import('../battles/BattleModal.vue');

    export default {
        mixins: [paginate],
        props: {
            page: {
                type: [Number, String],
                default: null,
            },
            isTrainer: {
                type: Boolean,
                default: false,
            },
        },
        mounted() {
            this.fetchData();
        },
        data() {
            return {
                battles: [],
                currentPage: null,
                lastPage: null,
                isLoading: true,
                battle: null,
                showBattleModal: false,
            };
        },
        watch: {
            $route: {
                handler() {
                    this.fetchData();
                },
                immediate: true,
            },
        },
        methods: {
            fetchData() {
                this.isLoading = true;
                BattleApi.list({
                    page: this.page,
                    isTrainer: this.isTrainer,
                    course_type: _.kebabCase(this.course),
                }).then(data => {
                    this.lastPage = data.lastPage;
                    this.currentPage = data.currentPage;
                    if (this.lastPage > 0 && this.currentPage > this.lastPage) {
                        this.currentPage = this.lastPage;
                    }
                    this.battles = data.data;
                    this.isLoading = false;
                });
            },
            showListOpponents(battleId) {
                this.$router.push({ name: 'battles-training:opponents', params: { battleId: battleId } });
            },
            showBattle(battleId) {
                if (!this.user.isSuperadmin) {
                    return;
                }
                this.$router.push({ name: 'battle:show', params: { id: battleId } });
            },
            showDescription(battle) {
                this.showBattleModal = true;
                this.battle = battle;
            },
            handleBattleDelete(removedBattleId) {
                this.battles = this.battles.filter(battle => battle.id !== removedBattleId);
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
                course: state => state.trainer.course,
            }),
            battlesExists() {
                return !!(this.battles && this.battles.length);
            },
            isLastPage() {
                return this.currentPage === this.lastPage;
            },
            isFirstPage() {
                return !this.currentPage || this.currentPage === 1;
            },
        },
        components: {
            AchievementsBanner,
            Battle,
            BattleModal,
        },
    };
</script>

<style scoped lang="scss">
    .box {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        border-radius: 0;
        background: #ffffff;
        box-shadow: 0 0 54px #51a552;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 30px;
        @include media($sm) {
            border-radius: 40px;
        }
    }
    .box-body {
        width: 100%;
        height: 100%;
    }
    .box-body__title {
        white-space: nowrap;
        text-align: center;
        font-family: 'Appetite';
        font-size: 42px;
        line-height: 42px;
        color: #2187ff;
        margin-bottom: 15px;
        @media screen and (max-width: 600px) {
            font-size: 36px;
            white-space: normal;
        }
    }
    .box-body__create-battle {
        height: 100%;
        max-height: 30px;
        margin: 0 auto;
        padding: 20px;
        border-radius: 20px;
        text-align: center;
    }
    .battle-create-button {
        padding: 15px 30px;
        background: #2187ff;
        border-radius: 40px;
        text-align: center;
        font-family: 'Rubik';
        font-size: 16px;
        line-height: 19px;
        color: #ffffff;
        &:hover {
            background: #0070f4;
        }
    }
    .box-body__battles {
        .clickable {
            cursor: pointer;
        }
        margin-top: 30px;
        &:after {
            content: '';
            display: table;
            clear: both;
        }
        @media screen and (max-width: 768px) {
            &:after {
                display: block;
            }
        }
    }
    .box-body__battles_empty {
        font-family: Appetite;
        font-style: normal;
        font-weight: normal;
        font-size: 42px;
        line-height: 42px;
        text-align: center;
        color: #2187ff;
        margin: 6rem 0;
        @media screen and (max-width: 360px) {
            font-size: 32px;
            line-height: 32px;
            margin: 1rem 0 5rem 0;
        }
    }
    .box-body__pagination {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .pagination-pages-numbers {
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            .pagination-link {
                background: #ffffff;
                border: 1px solid #bdbdbd;
                box-sizing: border-box;
                border-radius: 5px;
                margin: 10px 5px;
                padding: 10px 16px;
                font-family: Rubik;
                font-style: normal;
                font-weight: 500;
                font-size: 16px;
                line-height: 19px;
                color: #000000;
            }
            .is-current {
                background: #2187ff;
                color: #ffffff;
            }
        }
        .next-page,
        .prev-page {
            display: flex;
            align-items: center;
        }
        .next-page {
            margin-left: 5px;
        }
        .prev-page {
            margin-right: 5px;
        }
    }
</style>
